import React from "react";
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export default function Preloader() {
    return <Spin indicator={<LoadingOutlined spin />} />
}
